
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/[category]",
      function () {
        return require("private-next-pages/auto-parts/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/[category]"])
      });
    }
  